// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__dO4NW","spinner":"LoadingSpinner_spinner__UnICz","spin":"LoadingSpinner_spin__UPoAk"};